<template>
    <div class="main">
        <add-service @service-add="addedServices"></add-service>
        <div class="content">
            <div class="form-row-line">
                <div class="form-field">
                    <button class="btn btn-success" type="button" data-bs-toggle="modal" data-bs-target="#add-service-modal">
                        Добавить услугу
                    </button>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_title">
                Список услуг
            </div>
            <div class="content_row col-4 center bold">
                <div>Название</div>
                <div>Измерение</div>
                <div>Описание</div>
                <div>Регулярность</div>
            </div>
            <div
                class="content_row col-4 center"
                v-for="(service, key) in services"
                :key="key"
                >
                <div>{{ service.NAME }}</div>
                <div>{{ service.METERING }}</div>
                <div>{{ service.DESCRIPTION }}</div>
                <div>{{ service.REGULAR }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from "@/config";
    import addService from "@/components/backoffice/org/ServicesAdd";

    export default {
        name: "Services",
        components: {
            addService
        },
        data() {
            return {
                url: config.backend_url,
                services: []
            };
        },
        computed: {},
        methods: {
            addedServices: function () {
                this.getServices();
            },
            getServices: function ()
            {
                this.$store
                        .dispatch("query/sendRequest", {
                            url: this.url + "services/get-user-services/",
                            data: {},
                            method: "POST"
                        })
                        .then(response => {
                            let data = response.data;
                            if (!data.error) {
                                let reverseData = [];
                                let reverseKey = Object.keys(data)
                                        .sort()
                                        .reverse();
                                reverseKey.forEach(function (key) {
                                    reverseData.push(data[key]);
                                });
                                this.services = reverseData;
                            }
                        });
            }
        },
        created() {
            this.getServices();
        }
    };
</script>
